import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extractAttribute',
  standalone: true,
})
export class ExtractAttributePipe implements PipeTransform {
  transform(item: any, attr: string): any {
    if (item instanceof Array) {
      return item.map((i: any) => this.transform(i, attr));
    } else {
      return item[attr];
    }
  }
}
